import React from "react";

const EnvRibbon = ( {env }: { env: "prod" | "uat" | "dev"}) => {
    if (env === "prod") return null;

    const message = env.toUpperCase();
    const color = env === "uat" ? "bg-pink-600" : "bg-purple-600";

    return (
        <div className="absolute top-[24px] right-0 z-10 pointer-events-none">
            <div
                className={`text-center translate-x-[8%] translate-y-[0px] rotate-45  ${color} text-white text-xs font-semibold shadow-md`}
                style={{
                    width: 120,
                    // padding: "4px 0",
                    // textAlign: "center",
                    // position: "absolute",
                    // top: 12,
                    // right: -40,

                }}
                >
                    {message}
                </div>
        </div>
    )
};

export default EnvRibbon;